import React from "react";
import { Accordion } from "../../../../../../../react-core/Html/Accordion";
import { CircleBtn, CircleBtnType } from "../../../../../../../react-core/Html/CircleBtn";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { AccountRoleActorCategory } from "../../../../../../../Wrap/Constants/Enums/AccountRoleActorCategory";
import { RelationshipType } from "../../../../../../../Wrap/Constants/Enums/Customer/RelationshipType";
import { Title } from "../../../../../../../Wrap/Constants/Enums/Title";
import { OrganisationMember } from "../../../../../../../Wrap/Models/Models/Customer/OrganisationMember";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { AddBeneficiary } from "./AddBeneficiary";

interface IBeneficiaryDetailProps extends IProcessComponentProps {
    data: Array<OrganisationMember>;
    memberNumber: number;
    ownerAdviserId: number;
}

interface IBeneficiaryDetailState {
    addBeneficiary: boolean;
    expandList: boolean[];
}

export class BeneficiaryDetail extends ProcessComponent<IBeneficiaryDetailProps, IBeneficiaryDetailState> {
    constructor(props: any) {
        super(props);
        this.state = {
            addBeneficiary: null,
            expandList: [],
        };
    }

    isValid() {
        return super.isValid() && this.checkMemberValidation();
    }

    private checkMemberValidation() {
        const { data } = this.props;
        const length = data.length;
        if (length == 0) {
            return true;
        } else if (data[length - 1].Relationships?.length == 0 || data[length - 1].Individual == null) {
            this.props.showErrorMsgPopUp(["Please complete beneficiary details"], true);
            return false;
        } else {
            return true;
        }
    }

    private addBeneficiary() {
        const { data } = this.props;
        if (data && data.length > 0 && (this.isValidChild(data.length - 1) == false || !this.checkMemberValidation())) {
            return;
        }
        this.onAddMember();
    }

    private onAddMember() {
        const { data, ownerAdviserId } = this.props;
        const { expandList } = this.state;

        const _members = data ? data.concat() : [];
        _members.push({
            Company: null,
            Individual: {
                PersonalDetails: { Title: Title.Mr },
                ActorCategory: AccountRoleActorCategory.Associate,
                ActorOwnerId: ownerAdviserId,
            },
            Relationships: [RelationshipType.Beneficiary],
            Percentage: 0,
        });
        this.props.onChange(_members);
        expandList[expandList.length - 1] = false;
        expandList.push(true);
        this.setState({ expandList: expandList });
    }

    private onRemoveMember(i) {
        const { data, onChange } = this.props;
        const { expandList } = this.state;
        const _data = data.concat();
        _data.splice(i, 1);
        expandList.splice(i, 1);
        this.props.onChange(_data);
        this.setState({ expandList: expandList });
    }

    private onMemberChange(changes, i) {
        const { data, onChange } = this.props;
        const _data = data.concat();
        const _item = _data[i];
        for (const key in changes) {
            _item[key] = changes[key];
        }
        _data[i] = _item;
        this.props.onChange(_data);
    }

    public render() {
        const { data, memberNumber } = this.props;
        return (
            <>
                <RadiosEditor
                    cssWrapper="rg-inline mb-16"
                    selected={this.state.addBeneficiary}
                    label={"Do you want to add additional beneficiaries?"}
                    options={[true, false]}
                    getText={(v) => (v ? "Yes" : "No")}
                    disabled={false}
                    required={"Please select"}
                    onChange={(v) => {
                        if (v) {
                            this.addBeneficiary();
                        } else {
                            this.props.onChange([]);
                        }
                        this.setState({ addBeneficiary: v });
                    }}
                />

                {this.state.addBeneficiary &&
                    data &&
                    data.map((ele, index) => {
                        return (
                            <Accordion
                                key={`New beneficiary - ${index + 1}`}
                                label={`Beneficiary - ${index + 1}`}
                                cssWrapper="accordion-simple"
                                onChange={(v) => (v ? true : this.isValidChild(index))}
                                isOpen={this.state.expandList[index]}
                            >
                                <AddBeneficiary
                                    data={ele.Individual}
                                    onChange={(change) => this.onMemberChange(change, index)}
                                    onRef={(ref) => {
                                        this.appendChild(ref, index);
                                    }}
                                    showErrorMsgPopUp={(msg, showNow) => this.props.showErrorMsgPopUp(msg, showNow)}
                                />
                                <CircleBtn
                                    type={CircleBtnType.remove}
                                    cssWrapper="mr-52"
                                    title="Remove this beneficiary"
                                    onClick={() => this.onRemoveMember(index)}
                                />
                            </Accordion>
                        );
                    })}

                {this.state.addBeneficiary && memberNumber < 20 && (
                    <CircleBtn
                        type={CircleBtnType.add}
                        title="Add another beneficiary"
                        onClick={() => this.addBeneficiary()}
                    />
                )}
            </>
        );
    }
}
